export function today(offset = 0) {
  const date = new Date();
  date.setDate(date.getDate() + offset);
  return date.toISOString().slice(0, 10);
}

export function addDays(date, offset) {
  if (!date) return "";
  const [y, m, d] = date.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  dt.setDate(dt.getDate() + offset);
  const pad = (n) => String(n).padStart(2, "0");
  return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}`;
}

export const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const WEEKDAY_NAMES = [
  "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",
];

export const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

function pad2(value) {
  return String(value).padStart(2, "0");
}

function toIso(year, month, day) {
  return `${year}-${pad2(month + 1)}-${pad2(day)}`;
}

function isRealDate(year, month, day) {
  if (month < 0 || month > 11) return false;
  const dt = new Date(year, month, day);
  return dt.getFullYear() === year && dt.getMonth() === month && dt.getDate() === day;
}

function monthFromName(name) {
  const key = String(name).slice(0, 3).toLowerCase();
  return MONTH_NAMES.findIndex((month) => month.toLowerCase().startsWith(key));
}

function weekdayFromName(name) {
  const key = String(name).slice(0, 3).toLowerCase();
  return WEEKDAY_NAMES.findIndex((day) => day.toLowerCase().startsWith(key));
}

export function formatDisplayDate(iso, options = {}) {
  const dt = parseDate(iso);
  if (!dt) return "";
  const day = `${pad2(dt.getDate())} ${MONTH_NAMES[dt.getMonth()]} ${dt.getFullYear()}`;
  if (!options.weekday) return day;
  return `${WEEKDAY_NAMES[dt.getDay()]}, ${day}`;
}

export function parseDisplayDate(text) {
  let raw = String(text ?? "").trim().replace(/\s+/g, " ");
  if (!raw) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;

  const leading = raw.match(/^([A-Za-z]+)\s*,?\s+(.+)$/);
  if (leading && weekdayFromName(leading[1]) >= 0) raw = leading[2].trim();

  const named = raw.match(/^(\d{1,2})[\s\-/.]+([A-Za-z]{3,9})[\s\-/.,]+(\d{4})$/);
  if (named) {
    const day = Number(named[1]);
    const month = monthFromName(named[2]);
    const year = Number(named[3]);
    if (month >= 0 && isRealDate(year, month, day)) return toIso(year, month, day);
    return "";
  }

  const numeric = raw.match(/^(\d{1,2})[\s\-/.]+(\d{1,2})[\s\-/.]+(\d{4})$/);
  if (numeric) {
    const day = Number(numeric[1]);
    const month = Number(numeric[2]) - 1;
    const year = Number(numeric[3]);
    if (isRealDate(year, month, day)) return toIso(year, month, day);
    return "";
  }

  return "";
}

export function parseDate(date) {
  if (!date) return null;
  const [y, m, d] = String(date).split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

export function dayOfWeek(date) {
  const dt = parseDate(date);
  return dt ? dt.getDay() : -1;
}

export function eachDay(start, end) {
  const days = [];
  if (!start || !end) return days;
  let cursor = start;
  while (cursor < end && days.length < 730) {
    days.push(cursor);
    cursor = addDays(cursor, 1);
  }
  return days;
}

export function differenceInNights(checkIn, checkOut) {
  return eachDay(checkIn, checkOut).length;
}
